var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "stop-watch-kind-list" }, [
      _c(
        "button",
        {
          staticClass: "stop-watch-kind-item",
          class: { active: _vm.selectedStopwatchType === "basic" },
          attrs: { value: "basic" },
          on: { click: _vm.onChangeKind },
        },
        [_vm._v(_vm._s(_vm.$t("camstudy.stopwatch.type.basic")))]
      ),
      _c(
        "button",
        {
          staticClass: "stop-watch-kind-item",
          class: { active: _vm.selectedStopwatchType === "cash-item-01" },
          attrs: { value: "cash-item-01" },
          on: { click: _vm.onChangeKind },
        },
        [_vm._v(_vm._s(_vm.$t("camstudy.stopwatch.type.six")))]
      ),
    ]),
    _vm.selectedStopwatchType === "basic"
      ? _c(
          "div",
          { staticClass: "stop-watch-item-list" },
          _vm._l(_vm.basicStopWatchList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "stop-watch-item",
                class: { active: _vm.selectedStopwatchSubType.id === item.id },
                on: { click: () => _vm.onChangeStopWatch(item) },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "stop-watch-time-basic",
                    style: {
                      fontStyle: item.font,
                      background: item.background,
                    },
                  },
                  [_vm._v("00:00:00")]
                ),
              ]
            )
          }),
          0
        )
      : _vm.selectedStopwatchType === "cash-item-01"
      ? _c(
          "div",
          {
            staticClass: "stop-watch-item-list",
            class: { "device-coordi": _vm.isDevicetest },
          },
          _vm._l(_vm.cashItemList, function (item) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "stop-watch-item",
                class: { active: _vm.selectedStopwatchSubType.id === item.id },
                on: { click: () => _vm.onChangeStopWatch(item) },
              },
              [
                _c("img", {
                  staticClass: "stop-watch-background-image",
                  attrs: {
                    src: _vm.getImageUrl(item.background),
                    alt: "background",
                  },
                }),
                _c("div", { staticClass: "stop-watch-time-basic" }, [
                  _vm._v("00:00:00"),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }